import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { RecalculateContract } from './recalculate-contracts.model';

export const entityName = 'InvoiceSchedule';

@Injectable()
export class RecalculateContractsDataService extends EfaactDataService<RecalculateContract> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: RecalculateContract): RecalculateContract {
        if (!item) {
            return {} as RecalculateContract;
        }
        return {
            ...item,
            id: item.ContractDesc,
            PeriodStartDate: moment(item.PeriodStartDate).isValid()
                ? moment(item.PeriodStartDate).toDate()
                : undefined,
            PeriodEndDate: moment(item.PeriodEndDate).isValid()
                ? moment(item.PeriodEndDate).toDate()
                : undefined
        };
    }
}
